import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export function useStorageMemoryCount(userId: string | undefined, enabled: boolean) {
  const query = useQuery({
    queryKey: ["storage-memory-count", userId],
    enabled: enabled && !!userId,
    staleTime: 60_000,
    queryFn: async () => {
      const { count } = await supabase
        .from("memories")
        .select("id", { count: "exact", head: true })
        .eq("user_id", userId!)
        .not("space_id", "is", null);
      return count ?? 0;
    },
  });

  return {
    data: query.data ?? 0,
    count: query.data ?? 0,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
